const adminApiBaseUri = process.env.REACT_APP_ADMIN_API_BASE_URI;

export const AdminApi = {
  POST_IDENTITY_LOGIN: adminApiBaseUri + "/api/identity/login",
  POST_IDENTITY_PASSCODE: adminApiBaseUri + "/api/identity/login/passcode",
  POST_IDENTITY_AUTHORIZED: adminApiBaseUri + "/api/identity/authorized",
  GET_PROJECTS: adminApiBaseUri + "/api/projects",
  GET_ORDER: adminApiBaseUri + "/api/orders",
  GET_TICKET: adminApiBaseUri + "/api/tickets",
  GET_TICKET_COUNT: adminApiBaseUri + "/api/tickets/event",
  GET_PRODUCT_DEPARTURES_COUNT: adminApiBaseUri + "/api/tickets/project",
  GET_SEARCH_ORDER_BY_ID: adminApiBaseUri + "/api/orders",
  GET_SEARCH_ORDER_BY_PHONE: adminApiBaseUri + "/api/orders/search/phone",
  POST_ACTIVATE_TICKET: adminApiBaseUri + "/api/tickets/activate",
};
